import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import OrderDetailPage from './pages/OrderDetail';
import ListOrder from './pages/ListOrder';

const Order = () => {
  return (
    <Routes>
      <Route path="/" element={<ListOrder />} />
      <Route path="/:id" element={<OrderDetailPage />} />
    </Routes>
  );
};

export default Order;
